module.exports = "<div id=\"loader\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/loader/loader.component.html
// module id = ./src/app/loader/loader.component.html
// module chunks = main